/* ---------------------------------------------------------------------
   gc-cart-undo: "Removed from cart · Undo", in the cart drawer and on /cart.
   Owner, 4 Oct 2026: "you remove from cart, but no way to undo that".

   When the shopper removes something (a line's Remove, its quantity stepper
   going to 0, a Leather Set's "Remove set", or "Remove all items"), the row
   it leaves behind says what went and offers Undo for 10 seconds. Undo puts
   back exactly what was removed, in ONE /cart/add.js call: the same variant,
   the same quantity and every property the line carried, hidden ones
   included (the initials and their _personalization_id, a set's _set_id,
   a bundle's flags). With the properties identical, Shopify gives the line
   back its own key, so to the cart it is the same line again.

   What belongs with a line comes back with it:
   - its engraving fee, the hidden personalization-fee line whose
     _personalization_link is the case's _personalization_id
     (gc-personalization-sync.js takes that fee out once its case is gone);
   - its $25 Minimalist Logo line, the one whose _logo_link is the case's
     _logo_id (Oct 2026: Undo brought the case back without it, and
     gc-logo-sync.js then took "Logo: Minimalist" off the case). Undo of
     the $25 line on its own gives its case "Logo: Minimalist" back, which
     gc-logo-sync.js took off when the line went;
   - a whole Leather Set after "Remove set": every line with that _set_id,
     the fee on its case included;
   - the gift box and priority processing the reconcilers in
     gc-cart-price.js took down because the basket shrank (the gift box only
     up to the units being put back, priority only if it was there before).
   Only what is still missing is added: everything is measured against a cart
   read at the moment Undo is pressed, so a fee the sync has not taken out yet
   is not added twice. Rewards are left to their own reconciler.

   The hold (Oct 2026). The reconcilers (gc-personalization-sync.js,
   gc-logo-sync.js, and the gift box, priority and keychain rules in
   gc-cart-price.js) write a second or two after every cart change, which
   is just when a shopper presses Undo, and two writes at once on one cart
   can cancel each other: the Undo add came back with the case in it, a fee
   removal sent in the same moment, and the cart ended without the case.
   So from the press until the lines are back, window.__gcCartHold() is
   true and those reconcilers write nothing and look again shortly. Writes
   already on their way land first; after the add the cart is read back,
   and a line that is still missing is added once more, then the hold ends
   and the reconcilers see the cart as Undo left it. The hold covers the
   restoring only, not the 10 seconds the row is offered: a removal nobody
   undoes is reconciled at once, as before, so no orphan fee stays in the
   cart (or reaches checkout) while the row is on screen. It also lapses by
   itself after 8 seconds, so a request that never answers cannot stop the
   reconcilers for good.

   How a removal is seen. A click on a remove control arms a short window
   (4 s). The cart write that follows it from the theme (theme.js posts
   /cart/change.js {id: key, quantity: 0}; gc-cart-price.js posts
   /cart/update.js for "Remove set" and /cart/clear.js for "Remove all") is
   matched to that click, and the cart as it was just before the write is
   the record of what to put back. That cart is the last one this page read
   when no write has happened since; otherwise it is read first, which holds
   the write back by one cart read. Writes nobody clicked for (the
   reconcilers) never produce an undo.

   Drawer: the theme removes and re-renders as before; the row is placed
   where the removed line was and put back after every re-render until it
   is answered or times out. /cart: the page reloads after every change
   (that is how this theme's cart page works), so the remove link is taken
   over: read the cart, remove by line key, keep the record for the reloaded
   page (sessionStorage), reload, show the row there.

   Accessibility: the row is a labelled group with a real button; the removal
   is announced in a polite live region outside the drawer (the drawer's own
   nodes are replaced on every re-render); when the removal took the focus
   with it, focus goes to Undo, and after Undo to the restored line. The timer
   stops while the row is hovered or has focus. Words: theme locale keys
   cart.general.removed, cart.general.undo and cart.items.update_error,
   rendered into the list by snippets/cart-items.liquid (data-gc-undo-t),
   translated in every language. Debug: window.__gcUndo.
   --------------------------------------------------------------------- */
(function () {
  if (window.__gcUndo || typeof window.fetch !== 'function') return;
  var U = window.__gcUndo = { recs: [], log: [] };

  var HOLD = 10000;                 /* ms the row offers Undo */
  var ARM = 4000;                   /* ms between a remove click and its write */
  var GIFT = window.__gcGiftVariant || 50241832059137;
  var PRIORITY = 50247219740929;
  var FEE = 'personalization-fee';
  var STORE = 'gcUndo';             /* /cart: the record across the reload */
  var STORE_CHK = 'gcUndoChk';      /* /cart: the fee check across the reload */
  var WRITE = /\/cart\/(add|change|update|clear)(\.js)?$/;
  var READ = /^(\/[a-z]{2,3}(-[a-z0-9]{2,4})?)?\/cart\.js$/i;
  var base = window.fetch;
  var T = null;                     /* the words, read from the list */
  var seq = 0, armed = null;
  var gen = 0, writing = 0, snap = null, snapGen = -1, snapAt = 0;
  var focusTo = null;               /* {key|sid, until}: where focus goes after Undo */
  /* the hold (see the note at the top): one token per Undo (and per fee check), each lapsing on its
     own HOLD_MAX after it was last renewed, so two Undos never end each other's hold */
  var HOLD_MAX = 8000;
  var holds = Object.create(null), holdSeq = 0;
  function hold(t) { t = t || 'h' + (++holdSeq); holds[t] = Date.now() + HOLD_MAX; return t; }
  function unhold(t) { delete holds[t]; }
  window.__gcCartHold = function () {
    var now = Date.now();
    for (var t in holds) { if (holds[t] > now) return true; delete holds[t]; }
    return false;
  };
  U.holds = holds;
  function noop() {}
  function note(m) { try { U.log.push([Date.now(), m]); if (U.log.length > 40) U.log.shift(); } catch (e) {} }

  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return r || '/';
  }
  function onPage() { return !!(window.theme && window.theme.pageType === 'cart') && !document.getElementById('sidebar-cart'); }
  function host() {
    return onPage() ? document.querySelector('[data-section-type="cart"]') : document.getElementById('sidebar-cart');
  }
  function words() {
    if (T) return T;
    var el = document.querySelector('[data-gc-undo-t]');
    if (el) { try { T = JSON.parse(el.getAttribute('data-gc-undo-t')); } catch (e) {} }
    return T || { removed: 'Removed from cart', undo: 'Undo', err: '' };
  }

  /* ---------------- cart reads and the record of the cart ---------------- */
  function keep(c) { if (c && c.items) { snap = c; snapGen = gen; snapAt = Date.now(); } }
  function fresh() { return snap && snapGen === gen && !writing && Date.now() - snapAt < 30000; }
  function readCart() {
    var g = gen;
    return base.call(window, '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (c) { if (g === gen && !writing) keep(c); return c; });
  }
  function qtyOf(cart, key) {
    var n = 0, it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) if (it[i].key === key) n += it[i].quantity;
    return n;
  }
  function qtyOfVariant(cart, id) {
    var n = 0, it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) if (it[i].variant_id === id || it[i].id === id) n += it[i].quantity;
    return n;
  }
  function byKey(cart, key) {
    var it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) if (it[i].key === key) return it[i];
    return null;
  }
  function type(l) { return String(l.type == null ? '' : l.type).toLowerCase().replace(/^\s+|\s+$/g, ''); }
  function slim(L) {
    var sp = L.selling_plan_allocation && L.selling_plan_allocation.selling_plan;
    return { key: L.key, id: L.variant_id, q: L.quantity, p: L.properties || {}, sp: sp ? sp.id : null,
             type: L.product_type || '', h: L.handle || '', title: L.product_title || '' };
  }
  /* bags and backpacks get no gift box: the same rule as gc-cart-price.js (window.__gcIsBag) */
  function bagRule(it) {
    var ty = String((it && it.product_type) || ''), ti = String((it && (it.product_title || it.title)) || '');
    if (typeof window.GC_isBagType === 'function') return !!window.GC_isBagType(ty, ti);
    if (/Luggage Accessories/i.test(ty)) return false;
    if (/Luggage & Bags|Luggage &amp; Bags|Motorcycle Bags/i.test(ty)) return true;
    return /(^|[^A-Za-z\u00C0-\u024F])(bags?|backpacks?)(?![A-Za-z\u00C0-\u024F])/i.test(ti);
  }
  function isBag(l) {
    var it = { product_type: l.type, product_title: l.title };
    return typeof window.__gcIsBag === 'function' ? window.__gcIsBag(it) : bagRule(it);
  }
  function giftable(l) { var t = type(l); return t !== 'add-on' && t !== 'reward' && l.id !== GIFT && !isBag(l); }
  function item(l, q) {
    var o = { id: l.id, quantity: q }, p = {}, n = 0;
    for (var k in l.p) if (Object.prototype.hasOwnProperty.call(l.p, k) && l.p[k] !== undefined && l.p[k] !== null) { p[k] = l.p[k]; n++; }
    if (n) o.properties = p;
    if (l.sp) o.selling_plan = l.sp;
    return o;
  }

  /* what a matched removal took out, as a record to put back */
  function record(hit, after) {
    var s = hit.snap, gone = [], i;
    if (!s || !s.items) return null;
    if (hit.kind === 'line') {
      var L = byKey(s, hit.key) || (hit.line ? s.items[hit.line - 1] : null);
      if (L) gone.push(L);
    } else if (hit.kind === 'set') {
      var up = hit.updates || {};
      if (Array.isArray(up)) { for (i = 0; i < up.length; i++) if (+up[i] === 0 && s.items[i]) gone.push(s.items[i]); }
      else for (var k in up) if (Object.prototype.hasOwnProperty.call(up, k) && +up[k] === 0) { var M = byKey(s, k); if (M) gone.push(M); }
    } else {
      gone = s.items.slice();
    }
    gone = gone.filter(function (L) {
      return String(L.product_type || '').toLowerCase().trim() !== 'reward' && (!after || qtyOf(after, L.key) < L.quantity);
    });
    if (!gone.length) return null;
    var ids = {}, logos = {}, links = {}, lines = gone.slice(), relink = [];
    gone.forEach(function (L) {
      var p = L.properties || {};
      if (p._personalization_id) ids[String(p._personalization_id)] = 1;
      if (p._logo_id) logos[String(p._logo_id)] = 1;
      if (p._logo_link) links[String(p._logo_link)] = 1;
    });
    s.items.forEach(function (L) {
      var p = L.properties || {};
      if (lines.indexOf(L) >= 0) return;
      /* the fees of what went: the engraving fee, and the $25 Minimalist Logo line (Oct 2026) */
      if ((p._personalization_link && ids[String(p._personalization_link)]) ||
          (p._logo_link && logos[String(p._logo_link)])) lines.push(L);
      /* the $25 line went on its own: the case it belongs to stays, and gets its logo back with it */
      else if (p._logo_id && links[String(p._logo_id)]) relink.push(slim(L));
    });
    var gift = null, prio = null;
    s.items.forEach(function (L) {
      if (lines.indexOf(L) >= 0) return;
      if (L.variant_id === GIFT) gift = slim(L);
      if (L.variant_id === PRIORITY) prio = slim(L);
    });
    return { id: ++seq, kind: hit.kind, kbd: !!hit.kbd, lines: lines.map(slim), relink: relink, gift: gift, prio: prio,
             info: hit.info || {}, t: words(), at: Date.now() };
  }

  /* ---------------- the removal, seen on its way to the cart ---------------- */
  function match(path, body) {
    var a = armed;
    if (!a || Date.now() - a.at > ARM) return null;
    var b = null;
    if (typeof body === 'string') { try { b = JSON.parse(body); } catch (e) {} }
    if (/\/cart\/change/.test(path)) {
      if (a.kind !== 'line' || !b || parseInt(b.quantity, 10) !== 0) return null;
      var byId = b.id != null && String(b.id) === a.key;
      var byLine = b.id == null && b.line != null && String(b.line) === a.line;
      if (!byId && !byLine) return null;
      armed = null;
      return { kind: 'line', key: a.key, line: byLine ? parseInt(b.line, 10) : 0, kbd: a.kbd, info: a.info };
    }
    if (/\/cart\/update/.test(path)) {
      if (a.kind !== 'set' || !b || !b.updates) return null;
      armed = null;
      return { kind: 'set', updates: b.updates, kbd: a.kbd, info: a.info };
    }
    if (/\/cart\/clear/.test(path)) {
      if (a.kind !== 'all') return null;
      armed = null;
      return { kind: 'all', kbd: a.kbd, info: a.info };
    }
    return null;
  }

  function parse(u) {
    try { return new URL(typeof u === 'string' ? u : (u && u.url) || String(u), location.href); } catch (e) { return null; }
  }
  window.fetch = function (u, init) {
    var url = parse(u);
    if (!url || url.origin !== location.origin) return base.apply(this, arguments);
    var isReq = typeof Request !== 'undefined' && u instanceof Request;
    var method = String((init && init.method) || (isReq && u.method) || 'GET').toUpperCase();
    var self = this, args = arguments, out;
    if (method === 'GET' && !url.search && READ.test(url.pathname)) {
      var g = gen;
      out = base.apply(this, arguments);
      out.then(function (r) {
        if (r && r.ok) return r.clone().json().then(function (c) { if (g === gen && !writing) keep(c); });
      }).catch(noop);
      return out;
    }
    if (method === 'POST' && WRITE.test(url.pathname)) {
  var hit = match(url.pathname, init && init.body);
      var isCart = /\/cart\/(change|update|clear)/.test(url.pathname);
      if (hit) {
        var mine = fresh() ? Promise.resolve(snap) : readCart().catch(function () { return null; });
        gen++; writing++;
        out = mine.then(function (s) { hit.snap = s; return base.apply(self, args); });
        note('removal ' + hit.kind);
      } else {
        gen++; writing++;
        out = base.apply(this, arguments);
      }
      out.then(function (r) {
        writing = Math.max(0, writing - 1); gen++;
        if (!r || !r.ok) return;
        return r.clone().json().then(function (c) {
          if (isCart && c && c.items && !writing) keep(c);
          if (hit) { var rec = record(hit, isCart ? c : null); if (rec) show(rec, true); }
        });
      }, function () { writing = Math.max(0, writing - 1); gen++; }).catch(noop);
      return out;
    }
    return base.apply(this, arguments);
  };
  /* writes over XMLHttpRequest (the personalize drawer's add) also make the record stale */
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) {
    this.__gcUndoW = String(m).toUpperCase() !== 'GET' && /\/cart\/(add|change|update|clear)/.test(String(u));
    return xo.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__gcUndoW) { gen++; writing++; this.addEventListener('loadend', function () { writing = Math.max(0, writing - 1); gen++; }); }
    return xs.apply(this, arguments);
  };

  /* ---------------- what the shopper clicked ---------------- */
  function topRow(list, el) {
    while (el && el.parentNode !== list) el = el.parentNode;
    return el && el.parentNode === list ? el : null;
  }
  function rowId(el) {
    if (!el || el.nodeType !== 1) return null;
    var k = el.getAttribute('data-line-key');
    if (k) return 'k:' + k;
    var s = el.querySelector('[data-gc-set-key]');
    return s ? 's:' + s.getAttribute('data-gc-set-key') : null;
  }
  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function keepCss() {
    if (document.getElementById('gc-ci-css-keep')) return;
    var s = document.querySelector('style[data-gc-ci-css]');
    if (!s) return;
    var c = document.createElement('style');
    c.id = 'gc-ci-css-keep';
    c.textContent = s.textContent;
    document.head.appendChild(c);
  }
  /* title, picture (with the engraved initials when the row has them) and place of what is being removed */
  function info(ctrl, kind) {
    var h = host(), list = h && h.querySelector('.Cart__ItemList');
    var o = { title: '', img: '', ov: '', next: null };
    if (!list) return o;
    var top = topRow(list, ctrl);
    if (kind === 'all') return o;
    if (top) {
      var n = top.nextElementSibling;
      while (n && (n.hasAttribute('data-gc-undo-row') || !rowId(n))) n = n.nextElementSibling;
      o.next = rowId(n);
    }
    var piece = ctrl.closest('.gc-lset__piece');
    var set = ctrl.closest('.gc-lset');
    var img;
    if (kind === 'line' && piece) {
      o.title = txt(piece.querySelector('.gc-lset__name'));
      img = piece.querySelector('img');
    } else if (set) {
      o.title = txt(set.querySelector('.CartItem__Title'));
      img = set.querySelector('.gc-lset__tile');
    } else if (top) {
      o.title = txt(top.querySelector('.CartItem__Title'));
      img = top.querySelector('img.CartItem__Image');
      var ov = top.querySelector('.CartItem__ImageWrapper .gc-ci-ini');
      if (ov) { o.ov = ov.outerHTML; keepCss(); }
    }
    if (img) o.img = img.currentSrc || img.src || '';
    return o;
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var h = host();
    if (!h || !h.contains(t)) return;
    words();
    var go = t.closest('[data-gc-ask-go]');
    if (go) {
      var k = go.getAttribute('data-gc-ask-go');
      if (k === 'set' || k === 'all') armed = { at: Date.now(), kind: k, kbd: e.detail === 0, info: info(go, k) };
      return;
    }
    var a = t.closest('[data-action="remove-item"], [data-action="update-item-quantity"]');
    if (!a || a.hasAttribute('data-gc-reward-decline')) return;
    if (a.getAttribute('data-action') === 'update-item-quantity' && a.getAttribute('data-quantity') !== '0') return;
    var key = a.getAttribute('data-line-key');
    if (!key) return;
    /* e.detail is 0 for a press from the keyboard (Enter / Space): only then does Undo take the focus */
    armed = { at: Date.now(), kind: 'line', key: key, line: a.getAttribute('data-line'), kbd: e.detail === 0, info: info(a, 'line') };
    if (onPage()) { e.preventDefault(); e.stopPropagation(); pageRemove(a, armed); }
  }, true);

  /* /cart: remove by key, keep the record for the reloaded page */
  var pageBusy = false;
  function pageRemove(a, arm) {
    if (pageBusy) return;
    pageBusy = true;
    armed = null;
    a.setAttribute('aria-busy', 'true');
    var before = null;
    readCart().then(function (s) {
      before = s;
      return base.call(window, root() + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: arm.key, quantity: 0 })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      return r.json();
    }).then(function (after) {
      var rec = record({ kind: 'line', key: arm.key, snap: before, kbd: arm.kbd, info: arm.info }, after);
      if (rec) save(STORE, rec);
      location.reload();
    }).catch(function () {
      /* the theme's own way: the link itself */
      location.href = a.href;
    });
  }
  function save(k, v) { try { sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function load(k) { try { var v = sessionStorage.getItem(k); sessionStorage.removeItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }

  /* ---------------- the row ---------------- */
  var sr = null;
  function say(text) {
    if (!text) return;
    if (!sr) {
      sr = document.createElement('div');
      sr.className = 'gc-undo-sr';
      sr.setAttribute('role', 'status');
      sr.setAttribute('aria-live', 'polite');
      sr.setAttribute('aria-atomic', 'true');
      document.body.appendChild(sr);
    }
    sr.textContent = '';
    setTimeout(function () { sr.textContent = text; }, 150);
  }
  function css() {
    if (document.getElementById('gc-undo-css')) return;
    var s = document.createElement('style');
    s.id = 'gc-undo-css';
    s.textContent =
      '.gc-undo{position:relative;display:flex;flex-wrap:wrap;align-items:center;gap:10px 12px;box-sizing:border-box;width:100%;margin:0;padding:12px 2px 14px;border-bottom:1px solid rgba(28,27,27,.1);font-size:13px;line-height:1.35;color:#1c1b1b;text-align:start;animation:gcUndoIn .28s ease both}' +
      '.gc-undo__img{position:relative;flex:none;width:46px;border-radius:6px;overflow:hidden;background:#f4f3f1}' +
      '.gc-undo__img img{display:block;width:100%;height:auto}' +
      /* the stamp keeps the cart line's 6/n step (--gc-ini-s) and its length (--gc-ini-n), inline on the copied overlay.
         The 5px floor beat the step: eight wide letters (WWWWWWWW) ran to 9-91% of this 46px picture, the case being
         30-70% (Oct 2026). The floor now never makes the word wider than six letters take at the design size (68.4cqi
         shared by n letters, as on the cart line): eight W keep to 33-67%, one to three letters stay 4-5px. Without
         container units the picture is still 46px (plate ~18px): 12px / n is the same rule */
      '.gc-undo__img .gc-ci-ini{opacity:1}.gc-undo__img .gc-ci-ini__t{font-size:min(5px,calc(12px / var(--gc-ini-n,6)))}@supports (font-size:1cqi){.gc-undo__img .gc-ci-ini__t{font-size:max(min(5px,calc(68.4cqi / var(--gc-ini-n,6))),calc(11.4cqi * var(--gc-ini-s,1)))}}' +
      '.gc-undo__txt{flex:1 1 0;min-width:0;display:flex;flex-direction:column;gap:2px}' +
      '.gc-undo__name{font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}' +
      '.gc-undo__st{color:#5f5d5a}' +
      '.gc-undo__btn{flex:none;min-height:44px;min-width:64px;margin:0;padding:0 18px;border:1px solid #1c1b1b;border-radius:999px;background:#fff;color:#1c1b1b;font:inherit;font-weight:600;letter-spacing:.02em;line-height:1;cursor:pointer;-webkit-tap-highlight-color:transparent;transition:background-color .15s ease,color .15s ease}' +
      '@media (hover:hover){.gc-undo__btn:hover{background:#1c1b1b;color:#fff}}' +
      '.gc-undo__btn:focus{outline:none}.gc-undo__btn:focus-visible{outline:2px solid #1c1b1b;outline-offset:2px}' +
      '.gc-undo__btn[aria-busy="true"]{opacity:.55;cursor:progress}' +
      '.gc-undo__err{flex:1 1 100%;margin:0;color:#a3122a;font-size:12px}.gc-undo__err:empty{display:none}' +
      '.gc-undo__bar{position:absolute;left:0;right:0;bottom:-1px;height:2px;background:#1c1b1b;opacity:.3;transform-origin:left center;animation-name:gcUndoBar;animation-timing-function:linear;animation-fill-mode:both}' +
      '[dir="rtl"] .gc-undo__bar{transform-origin:right center}' +
      '.gc-undo.is-paused .gc-undo__bar{animation-play-state:paused}' +
      '.gc-undo.is-out{opacity:0;transition:opacity .25s ease}' +
      '.Cart--expanded > .gc-undo{margin-bottom:8px}' +
      '@keyframes gcUndoBar{from{transform:scaleX(1)}to{transform:scaleX(0)}}' +
      '@keyframes gcUndoIn{from{opacity:0;transform:translateY(-4px)}}' +
      '@media (prefers-reduced-motion:reduce){.gc-undo{animation:none}.gc-undo__bar{display:none}}' +
      '.gc-undo-sr{position:absolute!important;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap}';
    document.head.appendChild(s);
  }

  function left(rec) { return rec.paused ? rec.left : Math.max(0, rec.left - (Date.now() - rec.t0)); }
  function run(rec) {
    clearTimeout(rec.timer);
    rec.t0 = Date.now();
    rec.timer = setTimeout(function () { expire(rec); }, rec.left);
  }
  function pause(rec, on) {
    if (rec.done || rec.busy) return;
    if (on && !rec.paused) { rec.left = left(rec); rec.paused = true; clearTimeout(rec.timer); }
    else if (!on && rec.paused) { rec.paused = false; run(rec); }
    var row = rowOf(rec);
    if (row) row.classList.toggle('is-paused', rec.paused);
  }
  function rowOf(rec) { return document.querySelector('[data-gc-undo-row="' + rec.id + '"]'); }
  function drop(rec) {
    rec.done = true;
    clearTimeout(rec.timer);
    var i = U.recs.indexOf(rec);
    if (i >= 0) U.recs.splice(i, 1);
  }
  function expire(rec) {
    if (rec.done || rec.busy) return;
    var row = rowOf(rec);
    drop(rec);
    if (!row) return;
    var had = row.contains(document.activeElement);
    row.classList.add('is-out');
    setTimeout(function () {
      if (row.parentNode) row.parentNode.removeChild(row);
      if (had) { var h = host(); var c = h && h.querySelector('.Drawer__Close'); if (c) c.focus(); }
    }, 260);
  }

  function build(rec) {
    var t = rec.t || words();
    var row = document.createElement('div');
    row.className = 'gc-undo' + (rec.paused ? ' is-paused' : '');
    row.setAttribute('data-gc-undo-row', rec.id);
    row.setAttribute('role', 'group');
    var tid = 'gc-undo-t' + rec.id;
    row.setAttribute('aria-labelledby', tid);
    if (rec.info.img) {
      var m = document.createElement('span');
      m.className = 'gc-undo__img';
      m.setAttribute('aria-hidden', 'true');
      var im = document.createElement('img');
      im.src = rec.info.img; im.alt = ''; im.width = 46; im.decoding = 'async';
      m.appendChild(im);
      if (rec.info.ov) m.insertAdjacentHTML('beforeend', rec.info.ov);
      row.appendChild(m);
    }
    var tx = document.createElement('span');
    tx.className = 'gc-undo__txt'; tx.id = tid;
    if (rec.info.title) {
      var nm = document.createElement('span');
      nm.className = 'gc-undo__name'; nm.textContent = rec.info.title;
      tx.appendChild(nm);
    }
    var st = document.createElement('span');
    st.className = 'gc-undo__st'; st.textContent = t.removed;
    tx.appendChild(st);
    row.appendChild(tx);
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'gc-undo__btn';
    b.setAttribute('data-gc-undo-go', rec.id);
    b.textContent = t.undo;
    b.setAttribute('aria-describedby', tid);
    if (rec.busy) { b.disabled = true; b.setAttribute('aria-busy', 'true'); }
    row.appendChild(b);
    var er = document.createElement('p');
    er.className = 'gc-undo__err'; er.setAttribute('role', 'alert');
    if (rec.err) er.textContent = t.err || '';
    row.appendChild(er);
    var bar = document.createElement('span');
    bar.className = 'gc-undo__bar'; bar.setAttribute('aria-hidden', 'true');
    bar.style.animationDuration = HOLD + 'ms';
    bar.style.animationDelay = -(HOLD - left(rec)) + 'ms';
    row.appendChild(bar);
    row.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') { rec.hover = true; pause(rec, true); } });
    row.addEventListener('pointerleave', function () { rec.hover = false; if (!rec.focus) pause(rec, false); });
    row.addEventListener('focusin', function () { rec.focus = true; pause(rec, true); });
    row.addEventListener('focusout', function () {
      /* a re-render that replaced the row keeps the state for the new row (place() puts focus back) */
      setTimeout(function () {
        if (!row.isConnected || row.contains(document.activeElement)) return;
        rec.focus = false; if (!rec.hover) pause(rec, false);
      }, 0);
    });
    return row;
  }

  function findRow(list, id) {
    if (!id) return null;
    var v = id.slice(2), sel = id.charAt(0) === 'k' ? '[data-line-key]' : '[data-gc-set-key]';
    var attr = id.charAt(0) === 'k' ? 'data-line-key' : 'data-gc-set-key';
    var all = list.querySelectorAll(sel);
    for (var i = 0; i < all.length; i++) if (all[i].getAttribute(attr) === v) return topRow(list, all[i]);
    return null;
  }
  function lost() {
    var a = document.activeElement;
    return !a || a === document.body || a === document.documentElement || !document.contains(a);
  }
  function place(rec) {
    var h = host();
    if (!h || rec.done) return;
    var row = h.querySelector('[data-gc-undo-row="' + rec.id + '"]');
    if (!row) {
      css();
      row = build(rec);
      var list = h.querySelector('.Cart__ItemList');
      if (list) {
        var table = onPage() && window.getComputedStyle(list).display === 'table';
        var next = findRow(list, rec.info.next);
        if (table) list.parentNode.insertBefore(row, list);
        else if (next) list.insertBefore(row, next);
        else list.appendChild(row);
      } else {
        var empty = h.querySelector('[data-cart-empty], .EmptyState__Title');
        if (!empty) return;
        empty.parentNode.insertBefore(row, empty.nextSibling);
      }
      /* a pointer that was over the replaced row has not entered this one */
      if (rec.hover) { rec.hover = false; if (!rec.focus) pause(rec, false); }
    }
    if ((rec.focus || (rec.focusUntil && Date.now() < rec.focusUntil)) && lost()) {
      var b = row.querySelector('.gc-undo__btn');
      if (b) { b.focus({ preventScroll: true }); rec.focusUntil = 0; }
    }
  }
  function placeAll() {
    for (var i = 0; i < U.recs.length; i++) place(U.recs[i]);
    if (focusTo && lost()) {
      if (Date.now() > focusTo.until) { focusTo = null; return; }
      var h = host(), el = null;
      if (h && focusTo.key) {
        var all = h.querySelectorAll('[data-line-key]');
        for (var j = 0; j < all.length && !el; j++) if (all[j].getAttribute('data-line-key') === focusTo.key) el = all[j];
      }
      var f = el && (el.closest('.gc-lset') ? el.closest('.gc-lset').querySelector('[data-gc-set-toggle]') : el.querySelector('.CartItem__Title a, .CartItem__Title, a[href]'));
      if (f) {
        if (!f.matches('a, button, input, [tabindex]')) f.setAttribute('tabindex', '-1');
        f.focus({ preventScroll: true });
        focusTo = null;
      }
    }
  }

  function show(rec, now) {
    if (onPage() && now) return;            /* /cart: shown after the reload (pageRemove) */
    rec.left = HOLD; rec.paused = false;
    /* removed from the keyboard: the focus went with the removed row, so Undo gets it (on /cart, after the reload) */
    rec.focusUntil = rec.kbd ? Date.now() + 4000 : 0;
    U.recs.push(rec);
    /* analytics (assets/gc-track.js): the undo row is offered; its Undo press is read from data-gc-undo-go */
    try { document.dispatchEvent(new CustomEvent('gc:track', { detail: { name: 'cart_undo', action: 'offered' } })); } catch (e) {}
    run(rec);
    if (rec.info.ov) keepCss();
    say((rec.info.title ? rec.info.title + ' – ' : '') + (rec.t || words()).removed);
    placeAll();
    note('show ' + rec.id + ' lines ' + rec.lines.length);
  }

  /* ---------------- Undo ---------------- */
  /* X-GC-Undo: what Undo sends is put back as it was; the product page's Minimalist logo row
     (gc-logo-addon.js) leaves such an add untouched even while its square is ticked */
  function add(items) {
    return window.fetch(root() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-GC-Undo': '1' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  function change(op) {
    return window.fetch(root() + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-GC-Undo': '1' },
      body: JSON.stringify(op)
    }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
  }
  /* the cart writes already on their way when Undo is pressed (a reconciler's) land first */
  function drain() {
    var t0 = Date.now();
    return new Promise(function (done) {
      (function wait() { if (!writing || Date.now() - t0 > 4000) done(); else setTimeout(wait, 50); })();
    });
  }
  /* A line counts as back when the cart has its key, or the same variant with the same properties
     (blank ones aside: the store may keep or drop a blank value, and the key with it), so reading
     back after an add never adds a line twice. */
  function same(a, b) {
    var k, own = Object.prototype.hasOwnProperty;
    a = a || {}; b = b || {};
    for (k in a) if (own.call(a, k) && a[k] != null && a[k] !== '' && String(a[k]) !== String(b[k] == null ? '' : b[k])) return false;
    for (k in b) if (own.call(b, k) && b[k] != null && b[k] !== '' && String(b[k]) !== String(a[k] == null ? '' : a[k])) return false;
    return true;
  }
  function qtyLike(cart, l) {
    var n = 0, it = (cart && cart.items) || [];
    for (var i = 0; i < it.length; i++) if (it[i].key === l.key || (it[i].variant_id === l.id && same(it[i].properties, l.p))) n += it[i].quantity;
    return n;
  }
  function missing(lines, cart) {
    var out = [];
    (lines || []).forEach(function (l) { var need = l.q - qtyLike(cart, l); if (need > 0) out.push(item(l, need)); });
    return out;
  }
  /* Undo of the $25 line alone: gc-logo-sync.js has blanked its case by now ({Logo: '', _logo_id: ''},
     and its key changed with them), so that case gets the two back with the line. Only a line blanked
     that way is taken: the _logo_id key there and empty, the same variant and the same other properties,
     the same quantity first. A plain case of that variant never had the key and is never given the logo
     (review, Oct 2026: a newer plain line, listed first, got it, and the cart ended with the logo on the
     wrong case and two $25 units). A line with more units than the case had (it merged with another
     blanked one) is left as it is. Nothing found: nothing is relinked, and gc-logo-sync.js takes the $25
     line out again, so no logo is charged that is not on a case. */
  function relinks(rec, cart) {
    var ops = [], used = {}, own = Object.prototype.hasOwnProperty;
    (rec.relink || []).forEach(function (c) {
      if (qtyOf(cart, c.key) > 0) return;
      var want = {}, k, it = (cart && cart.items) || [], hit = null;
      for (k in c.p) if (k !== 'Logo' && k !== '_logo_id') want[k] = c.p[k];
      for (var i = 0; i < it.length; i++) {
        var p = it[i].properties || {}, got = {};
        if (it[i].variant_id !== c.id || used[it[i].key] || it[i].quantity > c.q ||
            !own.call(p, '_logo_id') || p._logo_id !== '') continue;
        for (k in p) if (k !== 'Logo' && k !== '_logo_id') got[k] = p[k];
        if (!same(got, want)) continue;
        if (!hit || (it[i].quantity === c.q && hit.quantity !== c.q)) hit = it[i];
      }
      if (hit) { used[hit.key] = 1; ops.push({ id: hit.key, quantity: hit.quantity, properties: c.p }); }
    });
    return ops;
  }
  function refresh() {
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e) {}
  }
  /* the engraving fee and the $25 Minimalist Logo line come back with their case; if a reconciler took
     one out in the same instant, put it back once (never a second one: only what is missing next to a
     case that is there). Under the hold, like Undo itself (Oct 2026). */
  function check(lines) {
    var fees = (lines || []).filter(function (l) { return l.p && (l.p._personalization_link || l.p._logo_link); });
    if (!fees.length) return;
    var added = false, h = hold();
    drain().then(readCart).then(function (cur) {
      var items = [];
      fees.forEach(function (l) {
        var lg = !l.p._personalization_link;
        var link = String(lg ? l.p._logo_link : l.p._personalization_link);
        var there = cur.items.some(function (it) { return it.properties && String(it.properties[lg ? '_logo_id' : '_personalization_id'] || '') === link; });
        var need = l.q - qtyLike(cur, l);
        if (there && need > 0) items.push(item(l, need));
      });
      if (items.length) { note('fee back ' + items.length); return add(items).then(function () { added = true; }); }
    }).catch(noop).then(function () {
      unhold(h);
      if (added) refresh();
    });
  }
  function restore(rec) {
    if (rec.busy || rec.done) return;
    rec.busy = true; rec.err = false;
    clearTimeout(rec.timer);
    var row = rowOf(rec), btn = row && row.querySelector('.gc-undo__btn'), er = row && row.querySelector('.gc-undo__err');
    if (btn) { btn.setAttribute('aria-busy', 'true'); }
    if (er) er.textContent = '';
    /* the hold: the reconcilers wait, and what they had already sent lands before the cart is read */
    var h = hold();
    drain().then(function () { hold(h); return readCart(); }).then(function (cur) {
      var items = [], units = 0;
      rec.lines.forEach(function (l) {
        var need = l.q - qtyOf(cur, l.key);
        if (need > 0) { items.push(item(l, need)); if (giftable(l)) units += need; }
      });
      if (rec.gift && units > 0) {
        var want = Math.min(rec.gift.q - qtyOfVariant(cur, GIFT), units);
        if (want > 0) items.push({ id: GIFT, quantity: want });
      }
      if (rec.prio && items.length && !qtyOfVariant(cur, PRIORITY)) items.push({ id: PRIORITY, quantity: 1 });
      note('undo ' + rec.id + ' items ' + items.length);
      U.last = items;
      return items.length ? add(items) : null;
    }).then(function () {
      /* read back: a line a write from elsewhere took out after all goes in once more */
      hold(h);
      return readCart().then(function (cur) {
        var again = missing(rec.lines, cur);
        if (!again.length) return cur;
        note('undo retry ' + again.length);
        return add(again).then(function () { return readCart(); });
      });
    }).then(function (cur) {
      /* a $25 line put back on its own: its case gets "Logo: Minimalist" back */
      return relinks(rec, cur).reduce(function (p, op) { return p.then(function () { return change(op); }); }, Promise.resolve());
    }).then(function () {
      var first = rec.lines[0];
      drop(rec);
      if (onPage()) {
        save(STORE_CHK, rec.lines);
        location.reload(); /* the hold lasts until this page goes */
        return;
      }
      unhold(h);
      if (row && row.contains(document.activeElement) || lost()) focusTo = { key: first && first.key, until: Date.now() + 5000 };
      if (row && row.parentNode) row.parentNode.removeChild(row);
      refresh();
      setTimeout(function () { check(rec.lines); }, 2500);
    }).catch(function () {
      unhold(h);
      rec.busy = false; rec.err = true;
      rec.left = HOLD; rec.paused = false; run(rec);
      var r2 = rowOf(rec);
      if (r2) {
        var b2 = r2.querySelector('.gc-undo__btn'), e2 = r2.querySelector('.gc-undo__err');
        if (b2) b2.removeAttribute('aria-busy');
        if (e2) e2.textContent = (rec.t || words()).err || '';
        var bar = r2.querySelector('.gc-undo__bar');
        if (bar) { var nb = bar.cloneNode(true); nb.style.animationDelay = '0ms'; bar.parentNode.replaceChild(nb, bar); }
      }
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-gc-undo-go]') : null;
    if (!b) return;
    e.preventDefault();
    var id = +b.getAttribute('data-gc-undo-go');
    for (var i = 0; i < U.recs.length; i++) if (U.recs[i].id === id) { restore(U.recs[i]); break; }
  });

  /* ---------------- after every re-render ---------------- */
  var queued = false;
  function start() {
    words();
    var saved = load(STORE);
    if (saved && saved.lines && Date.now() - saved.at < 60000) { seq = Math.max(seq, saved.id || 0); show(saved, false); }
    var chk = load(STORE_CHK);
    if (chk) setTimeout(function () { check(chk); }, 2500);
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if ((!U.recs.length && !focusTo) || queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; placeAll(); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
